import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Button = styled.button`
  padding: 5px 10px;

  border-color: transparent;
  background: var(--color-button-primary-bg);
  border: 1px solid var(--color-accent);
  border-radius: var(--radius-md);
  color: #f5f5f5;
  font-family: var(--font-body);
    font-size: var(--font-size-normal);
  cursor: pointer;

  &:hover {
    border-color: transparent;
    background: var(--color-accent);
    border: 1px solid var(--color-link-text);
    color: var(--color-link-text);
  }

  &:disabled {
    background: #d3d3d3;
    border: 1px solid #b0b0b0;
    color: #6b6b6b;
    cursor: not-allowed;
  }

  /* Add dynamic width and height */
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
`;

const TaskButton = ({
  onClick,
  children,
  className,
  width,
  height,
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      {...props}
    >
      {children}
    </Button>
  );
};

TaskButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

// TaskButton.defaultProps = {
//   onClick: () => {},
//   className: "",
//   width: "auto",
//   height: "auto",
// };

export default TaskButton;
